import React from 'react';
import HeaderContent from './header.content';
import { HeaderType } from '../../../types/app.types';
import { useParamsContext } from '../../../params/params-context';

interface HeaderProps {
  type: HeaderType;
  isFormPage?: boolean;
}

const Header: React.FunctionComponent<HeaderProps> = ({ type, isFormPage }) => {
  const { portalType } = useParamsContext();
  return (
    <HeaderContent
      titleText={[`header.${portalType}.${type}.title`, `header.${type}.title`]}
      contentText={[
        `header.${portalType}.${type}.content`,
        `header.${type}.content`
      ]}
      isFormPage={isFormPage}
    />
  );
};

export default Header;
